import React, {useEffect} from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import selector from './scene.selector';
// import Scene from '../../components/Scene';

import { colors } from '../../utils/variables.styles';
import Scene from "../../components/Scene";

const SceneWrapper = styled.div`
  height: calc(85vh - 118px);
  cursor: move;
  background: ${colors.white};
  margin-top: 10px;

  @media (max-width: 660px) {
    height: 202px;
  }

  @media (max-width: 1150px) {
    margin-bottom: 24px;
  }
`;

const SceneContainer = (props) => {

  return (
    <SceneWrapper>
      {
        props.constructionsLoaded ? (
          <Scene key={props.activeConstruction} {...props} />
        ) : 'Loading models...'
      }
    </SceneWrapper>
  );
};
export default connect(selector, null)(SceneContainer);
